import { Box, HStack, Image, Pressable } from 'native-base';
import React, { useState } from 'react';
import { colors } from '../../../styles';
import { CardBody, CardBodyProps } from './CardBody';
import { CardContainer } from './CardContainer';
import { CardTitle, CardTitleProps } from './CardTitle';

export type ActivityCardProps = CardTitleProps &
  CardBodyProps & {
    onPress?: () => void;
    thumbnailUrl?: string;
  };

export const ActivityCard: React.FC<ActivityCardProps> = (props) => {
  const [imageLoadError, setImageLoadError] = useState(false);
  const showThumbnail = props.thumbnailUrl && !imageLoadError;

  return (
    <Pressable onPress={props.onPress}>
      <CardContainer>
        <HStack>
          {showThumbnail && (
            <Image
              source={{ uri: props.thumbnailUrl }}
              alt={props.title || 'Event thumbnail'}
              width={60}
              height={60}
              borderRadius={6}
              mr={3}
              resizeMode="contain"
              onError={() => setImageLoadError(true)}
            />
          )}
          <Box flex={1} borderColor={colors.primary} borderLeftWidth={3} pl={4}>
            <CardTitle {...props} />
            <CardBody {...props} contentColor={colors.darkGrey} contentFontSize={13} contentMargin={0} />
          </Box>
        </HStack>
      </CardContainer>
    </Pressable>
  );
};
